function IconAntifraudeFalhaAnalise(props) {
  return (
    <svg 
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    width={props.width ? props.width : '25'}
    height={props.height ? props.height : '25'}
    fill="none"
    style={{ paddingRight: props.paddingRight }}
    >
      <path 
        fill={props.color ? props.color : '#FF4C51'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 15h2v2h-2zm0-8h2v6h-2zm1-5C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8"
      />
    </svg>

  );
}

export default IconAntifraudeFalhaAnalise;
